module.exports = __webpack_public_path__ + "static/img/footer-thzfw.b6cf11b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/global/footer-thzfw.png
// module id = 234
// module chunks = 0